export const ACTION_PROPS_STUDENTS = {
  ANONYMIZE_USERS_BULK: {
    unreverseMessage: true,
    confirmMessage: true
  },
  DELETE_USERS_BULK: {
    unreverseMessage: true
  },
  ACTIVATE_USERS_BULK: {},
  DEACTIVATE_USERS_BULK: {},
  UPDATE_TAGS_BULK: {}
};

export const BUTTON_ACTIONS_STUDENTS = [
  { id: 'students_list_bulk_edittags', key: '1', value: 'actions.editTags', profile: 'students.edit' },
  {
    id: 'students_list_bulk_sendpersonalizedemail',
    key: '2',
    value: 'actions.sendPersonalizedEmail',
    profile: 'students.sendPersonalizedEmail'
  },
  { id: 'students_list_bulk_anonymize', key: '3', value: 'actions.anonymize', profile: 'students.anonymize-bulk' },
  { id: 'students_list_bulk_delete', key: '4', value: 'actions.delete', profile: 'students.delete-bulk' },
  {
    id: 'students_list_bulk_sendwelcomeemail',
    key: '5',
    value: 'actions.sendWelcomeEmail',
    profile: 'students.sendWelcomeEmail'
  }
];

export const REQUIRED_FIELD_BATCH_STUDENTS = { email: 'email' };
export const REQUIRED_FIELD_BATCH_STUDENTS_BONUS_GROUP = { email: 'email', pid: 'pid' };
